import { createResolver } from "./Factories/ResolverFactory";
import type { Elements } from "@kontent-ai/delivery-sdk";
import { Roles } from "types/CMS/KontentAI/taxonomies/roles";
import { userRolesType } from "types/enums/User/Roles";


export const roleTaxonomyResolver = createResolver({
  resolve: (
    roles: Elements.TaxonomyElement<Roles, "roles">,
  ): userRolesType[] => {
    if (roles?.value === undefined || roles?.value?.length === 0) {
      return [];
    }
    return roles.value
      .map((role) => {
        return mapKontentRoleToUnum(role.codename);
      })
      .filter((item) => item !== undefined);
  },
});

const mapKontentRoleToUnum = (
  role: Roles,
): userRolesType | undefined => {
  if(role ==="help_at_hand_mi"){
    return "help-at-hand-mi";
  }

  return undefined;
};
